import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${(props) => props.theme.spacing.xxl}
    ${(props) => props.theme.spacing.lg};
  gap: ${(props) => props.theme.spacing.md};
  width: 100%;
`;

export const IconSlot = styled.div`
  color: ${(props) => props.theme.colors.label};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: ${(props) => props.theme.radii.pill};
  background: ${(props) => props.theme.colors.surfaceMuted};

  svg,
  img {
    width: 28px;
    height: 28px;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: ${(props) => props.theme.fontSizes.lg};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  color: ${(props) => props.theme.colors.darkerblue};
`;

export const Description = styled.p`
  margin: 0;
  max-width: 360px;
  font-size: ${(props) => props.theme.fontSizes.sm};
  color: ${(props) => props.theme.colors.label};
  line-height: 1.4;
`;

export const Action = styled.div`
  margin-top: ${(props) => props.theme.spacing.sm};
`;

// Botao ghost padrao da acao do EmptyState (ex.: "Limpar filtros").
export const ActionButton = styled.button`
  height: 34px;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid var(--cco-line);
  background: transparent;
  color: var(--cco-ink-mute);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: color 150ms, border-color 150ms;

  &:hover {
    color: var(--cco-ink);
    border-color: var(--cco-line-strong);
  }
`;
